<!-- 自动登录vems接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          parkCode: "2KPGDYCO",
          account: "kakaka",
          pwd: "123456"
        },
        responseCode: {
          "data": {
            "authLoginUrl": "http://localhost:8630/Api/automaticLoginVEMS",
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台自动登录vems接口",
          t_url: this.commonUrls.test + "automaticLoginVEMS",
          p_url: this.commonUrls.prod + "automaticLoginVEMS",
          precondition: "VEMS 2.16及以上版本",
          fitSystem: "VEMS传统停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'},
              {tableHead: '类型', tdName: 'info3'}, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'account', info2: '是', info3: 'String', info4: '账号'},
              {info1: 'pwd', info2: '是', info3: 'String', info4: '密码'},
              {info1: 'expireRedirectUrl', info2: '否', info3: 'String', info4: '链接失效重定向地址，不能含有‘#’。不填则默认http://openydt.yidianting.xin'},
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'},
              {tableHead: '类型', tdName: 'info3'}, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'authLoginUrl', info2: '是', info3: 'String', info4: '授权登陆地址'}
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/other/automaticLoginVEMS.vue